import React from "react";
import { twMerge } from "tailwind-merge";

const Description = ({ children, className = "" }) => {
  return (
    <p
      className={twMerge(
        "w-full justify-start text-center font-sans text-sm font-light tracking-wide text-gray-300",
        className
      )}
    >
      {children}
    </p>
  );
};

export default Description;
